export default __webpack_public_path__ + "static/hero_about_img_3-f3bd16de56c4b99871274b968652ba28.png";